import { REACT_APP_COOKIES_DOMAIN, STORAGE_PRFX } from "./constants";
import dateFns from "date-fns";

export const calculateNumberOfSurveyQuestions = (questionaire) => {
  return [].concat
    .apply(
      [],
      ((questionaire.draft_data || []).pages || []).map(
        (page) => page.questions,
      ),
    )
    .filter(
      (question) =>
        question.type !== "section" &&
        question.type !== "section-break" &&
        question.type !== "intro-text",
    ).length;
};

export const setActiveSurvey = (surveyId) => {
  setCookie("survey_id", surveyId);
};

export const getActiveSurvey = () => {
  return getCookie("survey_id");
};

export const styledDate = (dateValue, intl) => {
  var oneDay = 24 * 60 * 60 * 1000;
  var currentdate = new Date();
  var days = Math.abs(currentdate - new Date(dateValue)) / oneDay;

  if (days <= 1) {
    return intl.formatDate(dateValue, {
      hour: "numeric",
      minute: "numeric",
    });
  } else if (days <= 7) {
    return intl.formatDate(dateValue, {
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    });
  } else {
    return intl.formatDate(dateValue, {
      year: "numeric",
      day: "numeric",
      month: "short",
    });
  }
};

// ::: cookie
export const setCookie = (cname, cvalue, exdays = 7) => {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  // document.cookie = cname + '=' + cvalue + ';' + expires + ';domain=${REACT_APP_COOKIES_DOMAIN}';
  document.cookie = `${
    STORAGE_PRFX + cname
  }=${cvalue};${expires};path=/;domain=${REACT_APP_COOKIES_DOMAIN}`;
};

export const getCookie = (cname) => {
  var name = STORAGE_PRFX + cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      if (c.split("=")[1].length !== 0) {
        return c.substring(name.length, c.length);
      }
    }
  }
  return "";
};
export const delCookie = (cname) => {
  var expires = "expires=-1";
  document.cookie = `${
    STORAGE_PRFX + cname
  }=;${expires};path=/;domain=${REACT_APP_COOKIES_DOMAIN}`;
  // cname + '=' + ';' + expires + ';path=/';
  // document.cookie=`${cname}=;expires=Wed; 01 Jan 1970`
};

// ::: storage
export const setStorage = (name, value) => {
  return localStorage.setItem(STORAGE_PRFX + name, value);
};
export const getStorage = (name, value) => {
  return localStorage.getItem(STORAGE_PRFX + name, value);
};
export const delStorage = (name) => {
  return localStorage.removeItem(STORAGE_PRFX + name);
};

export const rerouteUser = (user) => {
  const canAccessAbis = hasP("APP_ACCESS_ABIS", user.role);
  const canAccessAnalytics = hasP("ACCESS_ANALYTICS", user.role);

  if (canAccessAnalytics) {
    return window.location.assign(
      process.env.REACT_APP_ANALYTICS_APP_URL
        ? `${process.env.REACT_APP_ANALYTICS_APP_URL}/en/`
        : "http://localhost:3001/en/",
    );
  }

  if (canAccessAbis) {
    return window.location.assign(
      process.env.REACT_APP_ABIS_APP_URL
        ? `${process.env.REACT_APP_ABIS_APP_URL}/en/`
        : "http://localhost:3002/en/",
    );
  }
};

const randId = (length) => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const idGenerator = (formId) => {
  return dateFns.format(new Date(), "YYMMDDHHssSSS") + randId(4) + "-" + formId;
};

export const PermissionsMap = {
  //insyt
  DownloadDocuments: "Download documents",
  FormSettings: "Form settings",
  EditFormSettings: "Edit form settings",
  ViewFormSettings: "View form settings",
  Geofence: "Geofence",
  RejectResponse: "Reject response",
  AccessTodo: "Access Todo",
  AccessQuestions: "Access Questions",
  AccessReports: "Access Reports",
  //account
  AssignRolesAndPermissions: "Assign roles and permissions",
  RevokeAccess: "Revoke access of any role",
  AllOtherPermissionsInclusive: "All other permissions inclusive",
  ViewAnalyticsDashboard: "View real-time analytics dashboard",
  ApproveReversalRequest:
    "Approve request for reversal of farmer compensation status",
  RejectReversalRequest:
    "Reject request for reversal of farmer compensation status",
  EditDocuments: "Edit documents",
  DeleteDocuments: "Delete documents",
  AttachDocument: "Attach document",
  Pending: "Pending",
  PendingVerified: "Pending Verified",
  RecheckResponse: "Recheck response",
  ChangeStatusVerifiedToPaymentRequested:
    "Change farmer status from 'Verified' to 'Payment Requested'",
  ChangeStatusPaymentRequestedToChequesGenerated:
    "Change farmer status from 'Payment Requested' to 'Cheques Generated'",
  CreateForm: "Create a form",
  ChangeStatusChequesGeneratedToPaid:
    "Change farmer status from 'Cheques Generated' to 'Paid'",
  PendingPaymentRequested: "Pending Payment Requested",
  PaymentRequested: "Payment Requested",
  PendingChequeGenerated: "Pending Cheque Generated",
  ChequeGenerated: "Cheque Generated",
  PendingPayment: "Pending Payment",
  Paid: "Paid",
  RequestSignatures: "Request Signatures",
};

export const systemResponseStatus = [
  "Pending Processing",
  "Pending Rechecking",
  "Overlap",
  "Recheck Submited",
  "Pending Payment Request",
  "Payment Request",
];

export const StatusRoleBasePermission = {
  "Super Adminstrator": [
    "Pending",
    "paid",
    "Pending Verification",
    "Verified",
    "Pending Payment Request",
    "Overlap",
    "Pending Compensation",
    "Recheck Submited",
    "Pending Rechecking",
    "Pending Processing",
    "Payment Request",
    "Pending Cheque Generation",
    "Cheque Generated",
    "Pending Payment",
    "Paid",
    "OK",
    "Rejected",
    "Compensation Accepted",
    "Payment Requested",
  ],

  "Super Administrator": [
    "Pending",
    "paid",
    "Pending Verification",
    "Verified",
    "Pending Payment Request",
    "Overlap",
    "Pending Compensation",
    "Recheck Submited",
    "Pending Rechecking",
    "Pending Processing",
    "Payment Request",
    "Pending Cheque Generation",
    "Cheque Generated",
    "Pending Payment",
    "Paid",
    "OK",
    "Rejected",
    "Compensation Accepted",
    "Payment Requested",
  ],

  Administrator: [
    "Pending",
    "paid",
    "Pending Verification",
    "Verified",
    "Pending Payment Request",
    "Overlap",
    "Pending Compensation",
    "Recheck Submited",
    "Pending Rechecking",
    "Pending Processing",
    "Payment Request",
    "Pending Cheque Generation",
    "Cheque Generated",
    "Pending Payment",
    "Paid",
    "OK",
    "Rejected",
    "Compensation Accepted",
    "Payment Requested",
  ],

  WBHO: [
    "Pending",
    "Pending Verification",
    "OK",
    "Pending Processing",
    "Pending Rechecking",
    "Recheck Submited",
  ],

  Operations: [
    "Pending",
    "Pending Verification",
    "OK",
    "Pending Processing",
    "Pending Rechecking",
    "Recheck Submited",
    // "Pending", "Pending Verification", "Verified", "Pending Payment Request",
    //  "Payment Request", "Pending Cheque Generation", "Cheque Generated", "Pending Payment", "Paid"
  ],
  //24,4164.2502
  "Resettlement Supervisor": [
    "Pending",
    "paid",
    "Pending Verification",
    "Verified",
    "Pending Payment Request",
    "Overlap",
    "Pending Compensation",
    "Recheck Submited",
    "Pending Rechecking",
    "Pending Processing",
    "Payment Request",
    "Pending Cheque Generation",
    "Cheque Generated",
    "Pending Payment",
    "Paid",
    "OK",
    "Rejected",
    "Compensation Accepted",
    "Payment Requested",
  ],
  "Data management manager": [
    "Pending",
    "paid",
    "Pending Verification",
    "Verified",
    "Pending Payment Request",
    "Overlap",
    "Pending Compensation",
    "Recheck Submited",
    "Pending Rechecking",
    "Pending Processing",
    "Payment Request",
    "Pending Cheque Generation",
    "Cheque Generated",
    "Pending Payment",
    "Paid",
    "OK",
    "Rejected",
    "Compensation Accepted",
    "Payment Requested",
  ],
  "Environmental Team": [
    "Pending",
    "Pending Verification",
    "Verified",
    "OK",
    "Pending Processing",
    "Pending Rechecking",
    "Recheck Submited",
    "Pending Compensation",
  ],
  "Validation team": [
    "Pending",
    "Pending Verification",
    "Verified",
    "OK",
    "Pending Processing",
    "Pending Rechecking",
    "Recheck Submited",
    "Pending Compensation",
  ],
  CFO: [
    "Pending Payment Request",
    ,
    "Payment Request",
    "Pending Cheque Generation",
    "Cheque Generated",
  ],
  "Finance officer": [
    "Pending Processing",
    "Pending Rechecking",
    "Recheck Submited",
    "Pending Compensation",
    "Compensation Accepted",
    "Pending Payment Request",
    "Payment Requested",
    "Pending Cheque Generation",
    "Cheque Generated",
    "paid",
    "Paid",
  ],
};

export const canViewStatus = (status) => {
  const user = JSON.parse(getCookie("user") || "{}");
  console.log(
    "canViewStatus",
    user,
    user.role,
    status,
    systemResponseStatus.includes(status),
  );
  if (user && user.role) {
    if (["Super Administrator", "Super Adminstrator"].includes(user.role))
      return true;
    if (systemResponseStatus.includes(status)) return false;
    if (StatusRoleBasePermission[user.role]) {
      return StatusRoleBasePermission[user.role]
        .map((el) => el.toLowerCase())
        .includes(status.toLowerCase());
    }
    return false;
  }
  console.warn("canAccess canViewStatus for undefined user or role");
  return false;
};

export const hasPermissionTo = (permission) => {
  const user = JSON.parse(getCookie("user") || "{}");
  if (user && user.permissions) {
    return (
      user.permissions.includes(permission) ||
      user.permissions.includes(PermissionsMap.AllOtherPermissionsInclusive)
    );
  }
  console.warn("canAccess permission for undefined user or permission");
  return false;
};
// check permission is deprecated
export const hasP = (permission, myRole) => {
  //alawys
  return true;
};

export function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function isEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export const imageExists = (img) => {
  var http = new XMLHttpRequest();
  http.open("HEAD", img, false);
  http.send();
  var status = http.status !== 404;
  return status ? img : require("../images/pngs/notfound.png");
};

const INVALID_QUESTION_TYPES = new Set(['NOT_FOUND', 'no-type']);

export const resolveQuestionType = (resp) => {
  if (resp.question_type && !INVALID_QUESTION_TYPES.has(resp.question_type)) {
    return resp.question_type;
  }
  if (resp.type && !INVALID_QUESTION_TYPES.has(resp.type)) {
    return resp.type;
  }
  return resp.question_type || resp.type || '';
};
